import { Spin } from 'antd';
import cn from 'classnames';
import { useCallback, useMemo, useState, type FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Error403Unauthorized } from '@app/components';
import { EditClient } from '@app/components/EditClient';
import { requestLeadCardRefresh } from '@app/components/LeadCard/model/leadCardRefreshSlice';
import { useNewUserAccessRights } from '@app/hooks';
import { useAppDispatch } from '@app/store';
import '@pages/EditClientPage/styles/EditClientPage.desktop.scss';

export const EditClientPage: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const clientId = useMemo(() => {
    const id = searchParams.get('id');
    const numberId = id ? Number(id) : null;
    const validId = Number.isNaN(numberId) ? null : numberId;
    return validId;
  }, [searchParams]);

  const leadId = useMemo(() => {
    const value = searchParams.get('leadId');
    const parsed = value ? Number(value) : null;
    return parsed !== null && Number.isFinite(parsed) ? parsed : null;
  }, [searchParams]);

  // Если сохранение происходит в карточке лида, обновляем страницу
  const handleAfterSave = useCallback(() => {
    if (leadId !== null) {
      dispatch(requestLeadCardRefresh(leadId));
    }
  }, [dispatch, leadId]);

  const {
    userAccessRights: {
      Clients: { IsEdit },
    },
  } = useNewUserAccessRights();

  if (!IsEdit) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="edit-client-page">
      <div
        className={cn('edit-client-page__loading', {
          'display-none': !isLoading && isInitialized,
        })}
      >
        <Spin size="default" spinning />
      </div>

      <div className="edit-client-page__content">
        <EditClient
          clientId={clientId}
          isInitialized={isInitialized}
          isLoading={isLoading}
          hasChanges={hasChanges}
          isOpen={IsEdit}
          setIsInitialized={setIsInitialized}
          setHasChanges={setHasChanges}
          setIsLoading={setIsLoading}
          afterSave={handleAfterSave}
        />
      </div>
    </div>
  );
};
